export const getImageUrl = (id: string): string => {
  const variant_name = "public";
  // return `https://imagedelivery.net/wZpbJM3t8iED5kIISxeUgQ/${id}/public`
  return `https://travelthru.com/cdn-cgi/imagedelivery/wZpbJM3t8iED5kIISxeUgQ/${id}/${variant_name}`;
};
